import styles from './IEPlug.module.scss';
import { ReactComponent as ChromeLogo } from '../../assets/chrome-logo.svg';
import { ReactComponent as FirefoxLogo } from '../../assets/firefox-logo.svg';
import { ReactComponent as EdgeLogo } from '../../assets/edge-logo.svg';
import { ReactComponent as OperaLogo } from '../../assets/opera-logo.svg';
import { ReactComponent as SadEmoji } from '../../assets/sad-emoji.svg';
import { useTranslation } from 'react-i18next';

export default function IEPlug(): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <p className={styles.header}>{t('ie_plug_title')}</p>
      <div className={styles.emojiWrapper}>
        <SadEmoji />
      </div>
      <p className={styles.header}>{t('ie_plug_subtitle')}</p>

      <div className={styles.browsers}>
        <div className={styles.browser}>
          <div className={styles.browserIcon}>
            <ChromeLogo />
          </div>
          <a
            className={styles.downloadLink}
            href='https://www.google.com/chrome/'
            rel='nofollow'
            target='_blank'
          >
            {t('ie_plug_download_chrome')}
          </a>
        </div>

        <div className={styles.browser}>
          <div className={styles.browserIcon}>
            <FirefoxLogo />
          </div>
          <a
            className={styles.downloadLink}
            href='https://www.mozilla.org/ru/firefox/new/'
            rel='nofollow'
            target='_blank'
          >
            {t('ie_plug_download_firefox')}
          </a>
        </div>

        <div className={styles.browser}>
          <div className={styles.browserIcon}>
            <EdgeLogo />
          </div>
          <a
            className={styles.downloadLink}
            href='https://www.microsoft.com/ru-ru/edge'
            rel='nofollow'
            target='_blank'
          >
            {t('ie_plug_download_edge')}
          </a>
        </div>

        <div className={styles.browser}>
          <div className={styles.browserIcon}>
            <OperaLogo />
          </div>
          <a
            className={styles.downloadLink}
            href='https://www.opera.com/ru'
            rel='nofollow'
            target='_blank'
          >
            {t('ie_plug_download_opera')}
          </a>
        </div>
      </div>
    </>
  );
}
